import React from 'react';
import './App.css';
import Loader from "./components/loader/Loader";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import {HashRouter, Route, Routes} from "react-router-dom";
import Auth0Provider from "./features/auth/auth0Provider";
import Layout from "./layouts/Layout";
import LoadingBlock from "./components/loader/LoadingBlock";
import ConfigurationDataProvider from "./features/configuration/ConfigurationDataProvider";


const Accounts = React.lazy(() => import("./features/account/Accounts"));
const Employees = React.lazy(() => import("./features/employee/Employees"));
const Print = React.lazy(() => import("./features/print/Prints"));
const Marking = React.lazy(() => import("./features/marking/Marking"));
const PrintCategories = React.lazy(() => import("./features/printCategory/PrintCategories"));
const Producers = React.lazy(() => import("./features/producer/Producers"));
const Measurements = React.lazy(() => import("./features/measurement/Measurements"));
const ErrorNotFound = React.lazy(() => import("./components/error/ErrorNotFound"));

function App() {

    return (
        <Auth0Provider>
            <HashRouter>
                <ConfigurationDataProvider>
                    <Layout>
                        <React.Suspense fallback={<LoadingBlock/>}>
                            <Routes>
                                <Route path="/accounts" element={<Accounts/>}/>
                                <Route path="/employees" element={<Employees/>}/>
                                <Route index element={<Print/>}/>
                                <Route path={"/marking"} element={<Marking/>}/>
                                <Route path="/print-categories" element={<PrintCategories/>}/>
                                <Route path="/producers" element={<Producers/>}/>
                                <Route path="/measurements" element={<Measurements/>}/>
                                <Route path="*" element={<ErrorNotFound/>}/>
                            </Routes>
                        </React.Suspense>
                    </Layout>
                </ConfigurationDataProvider>
            </HashRouter>
        </Auth0Provider>
    );
}

export default withAuthenticationRequired(App, {
    onRedirecting: () => <Loader/>
})

